var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"footer-bottom"},[_c('div',{staticClass:"box7"},[_vm._m(0),_c('p',[_vm._v(" Copyright © 2018-"+_vm._s(_vm.newYear)+". All Rights Reserved. 长春新区管理委员会 版权所有 ")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('img',{attrs:{"src":require("../assets/eduDefault/icon.png")}}),_vm._v("备案号：吉ICP备20000186号-1 联系我们：0431-80606821 技术支持：卓越科技 ")])
}]

export { render, staticRenderFns }